<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Patient Overview: Medical History</h2>

        <ul class="list-disc pl-4 font-light mb-6">
            <li>Has the patient been previously seen or treated for any symptoms of PH1?</li>
        </ul>

        <img
            src="@/assets/img/graphics/adolescent/patient-overview-desktop.svg"
            alt="Medical History"
            class="hidden md:block"
        />
        <img
            src="@/assets/img/graphics/adolescent/patient-overview-mobile.svg"
            alt="Medical History"
            class="md:hidden self-center"
        />
    </div>
</template>
